<template>
  <div>
    <el-card class="box-card">
      <ul class="basic-info">
        <li><span>ip:</span> {{detailsData.ip}}</li>
        <li><span>通道号:</span> {{detailsData.ch_num}}</li>
        <li><span>设备类型: </span>{{detailsData.type_used}}</li>
        <li><span>品牌:</span> {{detailsData.brand}}</li>
        <li><span>型号:</span> {{detailsData.model}}</li>
        <li><span>NVR IP:</span> {{detailsData.ntp_server_ip}}</li>
        <li><span>位置:</span> {{detailsData. floor_name}}</li>
        <li><span>密码:</span> {{detailsData. camera_pwd}}</li>
        <li><span>创建时间:</span> {{detailsData.created_at}}</li>
        <li><span>监控端:</span> {{detailsData.monitor_ip}}:{{detailsData.monitor_port}}</li>
      </ul>
      <div class="screenshot">
        <div class="screenshot-item">
          <h5>审核截图</h5>
          <img :src="detailsData.review_screenshot" >
        </div>
        <div class="screenshot-item">
          <h5>实时截图</h5>
          <img :src="detailsData.live_screenshot" >
        </div>
        <div class="screenshot-item">
          <h5>全景截图</h5>
          <img :src="detailsData.panoramic_view" >
        </div>
      </div>
    </el-card>
    <h4>操作日志</h4>
    <commonTable :table-data="operateLogsTableData"
                 :common-table-array="operateLogsTableArray"
                 :is-show-pagination="isShowPagination" />
    <h4>固件升级日志</h4>
    <commonTable :table-data="firmwareUpgradeLogsTableData"
                 :common-table-array="firmwareUpgradeLogsTableArray"
                 :is-show-pagination="isShowPagination" />
  </div>
</template>

<script>
import { pointQueryDetails, pointOperateLogs, pointFirmwareUpgradeLogs } from '@/api/devices';
import commonTable from '@/components/common/commonTable.vue';

export default {
  components: { commonTable },
  data() {
    return {
      detailsData: {},
      operateLogsTableData: [],
      operateLogsTableArray: [{
        label: '操作类型',
        props: 'op_type',
        filtersFlag: true,
      }, {
        label: '操作人',
        props: 'operator_name',
      }, {
        label: '操作记录',
        props: 'op_record',
      }, {
        label: '操作日期',
        props: 'created_at',
      }],
      isShowPagination: false,
      firmwareUpgradeLogsTableData: [],
      firmwareUpgradeLogsTableArray: [{
        label: '升级版本',
        props: 'new_version',
      }, {
        label: '历史版本',
        props: 'history_version',
      }, {
        label: '升级状态',
        props: 'upgrade_status',
        filtersFlag: true,
      }, {
        label: '升级日期',
        props: 'created_at',
      }],

    };
  },
  created() {
    this.pointDetails();
    this.getOperateLogs();
    this.getFirmwareUpgradeLogs();
  },
  methods: {
    pointDetails() {
      pointQueryDetails({ id: this.$route.params.id }).then((res) => {
        this.detailsData = res.data;
      });
    },
    getOperateLogs() {
      pointOperateLogs({ deploy_id: 1 }).then((res) => {
        this.operateLogsTableData = res.data;
      });
    },
    getFirmwareUpgradeLogs() {
      pointFirmwareUpgradeLogs({ deploy_id: 1 }).then((res) => {
        this.firmwareUpgradeLogsTableData = res.data;
      });
    },
  },
};
</script>
<style lang='less' scoped>
.basic-info{
  list-style: none;
  li{
    line-height: 2;
    font-size: 14px;
    span{
      color: #666;
      margin-right: 15px;
    }
  }
}
.screenshot{
  display: flex;
  padding-left: 40px;
  &-item{
    margin-right: 50px;
    img{
      max-width: 300px;
    }
  }
}
</style>
